<template>
  <div class="page mini-sidebar" :class="{ 'fixed-sidebar show-sidebar': this.showNavbar }">
    <div class="page-main">
      <!-- Navbar-->
      <header class="topbar">
        <nav class="navbar top-navbar navbar-expand-md navbar-dark">
          <div class="navbar-header">
            <router-link :to="{ name: 'index' }" class="navbar-brand">
              <img src="../assets/images/vnisys-logo.png" alt="homepage" class="d-none d-md-inline-block" width="141"
                style="margin-top: -15px" />
              <img src="../assets/images/vnisys-logo-mobile.png" class="light-logo d-md-none" width="45"
                alt="homepage" />
            </router-link>
          </div>
          <div class="navbar-collapse">
            <ul class="navbar-nav mr-auto">
              <li class="nav-item">
                <a class="nav-link nav-toggler d-block d-md-none waves-effect waves-dark" @click="() => toogleNavbar()">
                  <i :class="!this.showNavbar ? 'ti-menu' : 'ti-close'"></i>
                </a>
              </li>
              <li class="nav-item">
                <div class="app-search" :class="{ value }">
                  <autocomplete :search="searchCode" :placeholder="$t('common.search')"
                    :get-result-value="getResultValue" :debounce-time="200" :default-value="defaultCode"
                    @submit="onSubmit" ref="autocomplete">
                  </autocomplete>
                  <button @click="clear()" class="time-button">
                    <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
                      <path
                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                      <path d="M0 0h24v24H0z" fill="none" />
                    </svg>
                  </button>
                </div>
              </li>
            </ul>
            <!-- <ul class="navbar-nav">
              <li class="nav-item">
                <a class="nav-link nav-toggler waves-effect waves-dark" @click="() => collapseSidebar('request_stock')">
                  <i class="fas fa-file-medical large-icon"></i>
                </a>
              </li>
            </ul> -->
            <ul class="navbar-nav my-lg-0">
              <li class="nav-item right-side-toggle">
                <a class="nav-link  waves-effect waves-light" @click="() => collapseSidebar('settings_menu')">
                  <!-- <i class="ti-settings large-icon"></i> -->
                  <i class="fas fa-user large-icon"></i>
                </a>
              </li>
            </ul>
            <ul class="navbar-nav my-lg-0">
              <li class="nav-item right-side-toggle">
                <div class="notification-icon">
                  <a class="nav-link nav-toggler waves-effect waves-dark" @click="showNotification = true">
                    <i class="fas fa-bell"></i>
                  </a>
                  <span v-if="unreadNo > 0" class="notification-badge">{{ unreadNo }}</span>
                </div>
              </li>
            </ul>
          </div>
        </nav>
      </header>

      <aside class="left-sidebar">
        <!-- Sidebar scroll-->
        <div class="scroll-sidebar">
          <!-- Sidebar navigation-->
          <nav class="sidebar-nav">
            <ul id="sidebarnav">
              <li :class="activeMenu === 'index' ? 'active' : ''" id="dashboard">
                <router-link :to="{ name: 'index' }" class="waves-effect waves-dark" aria-expanded="false">
                  <i class="fas fa-home"></i>
                  <span class="hide-menu">{{ $t('pages.home') }}</span>
                </router-link>
              </li>
              <li :class="{
                active: activeMenu === 'stock_info'
              }">
                <router-link :to="{ name: 'overview' }" class="waves-effect waves-dark" aria-expanded="false">
                  <i class="fas fa-chart-line"></i>
                  <span class="hide-menu">{{ $t('pages.Overview') }}</span>
                </router-link>
              </li>
              <li v-if="currentUser.role !== 'FREE'" :class="{ active: activeMenu === 'MarketCycle' }">
                <router-link :to="{ name: 'market' }" class="waves-effect waves-dark" aria-expanded="false">
                  <i class="fas fa-wave-square"></i>
                  <span class="hide-menu">{{ $t('pages.market') }}</span>
                </router-link>
                <ul>
                  <li>
                    <router-link :to="{ name: 'market' }" class="waves-effect waves-dark" aria-expanded="false">
                      <i class="fas fa-globe"></i>
                      <span class="hide-menu"> {{ $t('pages.market_overview') }}</span>
                    </router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: 'marketSector' }" class="waves-effect waves-dark" aria-expanded="false">
                      <i class="fas fa-vector-square"></i>
                      <span class="hide-menu"> {{ $t('pages.market_sector') }}</span>
                    </router-link>
                  </li>
                </ul>
              </li>
              <li v-else :class="{ active: activeMenu === 'MarketCycle' }" class="bg-light d-block"
                @click="toggleUpgradePanel">
                <a class="waves-effect waves-dark">
                  <i class="fas fa-lock"></i>
                  <span class="hide-menu">{{ $t('pages.market') }}</span>
                </a>
              </li>
              <li v-if="currentUser.role === 'PREMIUM'" :class="{ active: activeMenu === 'ranking' }">
                <router-link :to="{ name: 'rankDca' }" class="waves-effect waves-dark" aria-expanded="false">
                  <i class="icon-trophy"></i>
                  <span class="hide-menu">{{ $t('ranking.title') }}</span>
                </router-link>
              </li>
              <li v-else aria-expanded="false" class="bg-light d-block" @click="toggleUpgradePanel">
                <a class="waves-effect waves-dark">
                  <i class="fas fa-lock"></i>
                  <span class="hide-menu">{{ $t('ranking.title') }}</span>
                </a>
              </li>
            </ul>
          </nav>
          <!-- End Sidebar navigation -->
        </div>
        <!-- End Sidebar scroll-->
      </aside>
    </div>
    <div class="right-sidebar ps ps--theme_default" :class="{ 'shw-rside': this.sidebarCollapse.request_stock }">
      <div class="slimscrollright">
        <div class="rpanel-title">
          {{ $t('request_stock') }} <span @click="() => collapseSidebar('request_stock')"><i
              class="ti-close right-side-toggle"></i></span>
        </div>
        <div class="r-panel-body user-info">
          <div class="text-button-container">
            <input class="searchText" type="text" v-model="requestedStock" :placeholder="$t('common.search')" />
            <link-button :classes="['btn-cyan']" :click="() => submitRequest()">
              <i class="fas fa-plus"></i>
            </link-button>
          </div>
          <loading-container :loading="form.requestsLoading">
            <div v-if="requests.total > 0" class="mt-2">
              <span class="pull-right">{{ $t('total') }}: {{ requests.total }}</span>
              <table class="table request-table">
                <thead>
                  <tr>
                    <th>Code</th>
                    <th>Status</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in requests.items" :key="index">
                    <td>{{ item.content }}</td>
                    <td>{{ item.status }}</td>
                    <td>
                      <span class="text-blue" @click="() => removeRequest(`${item.requestId}`)">
                        <i class="far fa-trash-alt"></i>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="row m-t-20 m-l-10">
              {{ $t('messages.request_no_result') }}
            </div>
          </loading-container>
        </div>
      </div>
    </div>

    <!-- Notification right-sidebar -->
    <div v-if="showNotification === true">
      <Notification :messages="messages" @close="showNotification = false" />
    </div>

    <!-- <Profile v-if="showProfile"/> -->
    <div class="page-wrapper">
      <div class="container-fluid">
        <div class="right-sidebar ps ps--theme_default settings-section"
          :class="{ 'shw-rside': this.sidebarCollapse.settings_menu }">
          <div class="slimscrollright">
            <div class="rpanel-title">
              {{ $t('setting') }} <span @click="() => collapseSidebar('settings_menu')"><i
                  class="ti-close right-side-toggle"></i></span>
            </div>
            <div class="r-panel-body user-info">
              <div class="text-left">
                <img :src="currentUserImage()" alt="user" class />
                <span class="user-info-name">
                  <router-link :to="{ name: 'profile' }">
                    <p>
                      {{ currentUser.name ? currentUser.name : currentUser.email }} - {{ currentUser.role }}
                    </p>
                    <p v-if="currentUser.role != 'PREMIUM'">
                      <link-button :classes="['btn-cyan']" :to="{ name: 'upgrade' }">
                        <i class="far fa-star"></i> {{ $t('buttons.upgrade') }}
                      </link-button>
                    </p>
                  </router-link>
                </span>
              </div>
              <div class="dropdown-divider"></div>
              <div class="text-left">
                <label>{{ $t('language') }}</label>
                <input-select :value="defaultLocale" name="sectors" class="m-0" :options="languageOptions"
                  @input="value => selectLanguage(value)" />
              </div>
              <div class="dropdown-divider"></div>
              <div class="text-left">
                <a @click="() => authLogout()" class="cursor-pointer">
                  <i class="fa fa-power-off"></i> {{ $t('logout') }}
                </a>
              </div>
            </div>
          </div>
        </div>
        <slot />
      </div>
    </div>
    <div v-if="showUpgrade">
      <div class="overlay"></div>
      <upgrade @cancel="closePanel" @upgrade="upgradeAndClosePanel"
        :style="{ top: panelPosition.top, left: panelPosition.left }"></upgrade>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import _ from "lodash";
import LinkButton from "@/components/Misc/LinkButton";
import AlertBox from "@/components/Misc/AlertBox";
import common from "@/libs/common";
import LoadingContainer from "@/components/Misc/LoadingContainer";
import Autocomplete from '@trevoreyre/autocomplete-vue';
import '@trevoreyre/autocomplete-vue/dist/style.css';
import webStorage from "@/libs/webStorage";
import InputSelect from "@/components/Form/InputSelect";
import Upgrade from '@/components/Form/Upgrade.vue';
import InputText from '@/components/Form/InputText';
import Profile from "./sidebars/Profile.vue";
import SearchStock from "../components/Common/SearchStock.vue";
import Notification from "./sidebars/Notification.vue";

export default {
  name: "DefaultTheme",
  components: {
    Profile,
    Notification,
    InputText,
    LinkButton,
    AlertBox,
    LoadingContainer,
    Autocomplete,
    InputSelect,
    SearchStock,
    Upgrade
  },
  data() {
    return {
      showProfile: true,
      showNavbar: false,
      sidebarCollapse: {},
      value: '',
      requestedStock: '',
      isLockedFeature: true,
      showUpgrade: false,
      panelPosition: { top: 0, left: 0 },
      showNotification: false
    };
  },
  beforeMount() {
    if (!this.userInfoLoaded) {
      this.getUserInfo();
    }
    this.getDefaultCode();
    this.getUnreadNo();
    this.value = this.defaultCode;
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      form: "stock/form",
      loading: "stock/loading",
      userInfoLoaded: "auth/userInfoLoaded",
      availableCodes: "evaluation/availableCodes",
      defaultCode: "configuration/defaultCode",
      langs: "configuration/langs",
      defaultLocale: "configuration/defaultLocale",
      requests: "stock/requests",
      unreadNo: "notification/unreadNo"
    }),
    currentUser() {
      return this.user || {};
    },
    currentRole() {
      return this.currentUser.role;
    },
    activeMenu() {
      return this.$store.state.route.meta.activeMenu;
    },
    languageOptions() {
      return this.langs;
    },
  },
  methods: {
    ...mapActions({
      authLogout: "auth/logout",
      getConfigFromAPI: "upload/getConfigFromAPI",
      getUserInfo: "auth/getUserInfo",
      setDefaultCode: "configuration/setDefaultCode",
      getDefaultCode: "configuration/getDefaultCode",
      clearDefaultCode: "configuration/clearDefaultCode",
      setLocale: "configuration/setLocale",
      getStockInfo: "stock/getStockInfo",
      getEvaluationCode: "evaluation/getEvaluationCode",
      getDCACode: "evaluation/getDCACode",
      requestNewStock: "stock/requestNewStock",
      getRequests: "stock/getRequests",
      removeRequest: "stock/removeRequest",
      getUnreadNo: "notification/getUnreadNo",
      getOverview: "stock/getOverview"
    }),
    toggleProfile() {
      this.showProfile = !this.showProfile;
    },
    closePanel() {
      this.showUpgrade = false;
      document.body.style.overflow = '';
    },
    upgradeAndClosePanel() {
      this.showUpgrade = false;
      document.body.style.overflow = '';
    },
    toggleUpgradePanel(event) {
      this.showUpgrade = !this.showUpgrade;
      if (this.showUpgrade) {
        this.panelPosition = {
          top: event.clientY + 10 + 'px',
          left: event.clientX + 'px'
        };
        document.body.style.overflow = 'hidden';
      }
    },
    submitRequest() {
      if (this.requestedStock) {
        this.requestNewStock(this.requestedStock);
        this.requestedStock = '';
      }
    },
    currentUserImage() {
      return `https://ui-avatars.com/api/?name=${this.currentUser.name}`;
    },
    toogleNavbar() {
      this.showNavbar = !this.showNavbar;
    },
    collapseSidebar(key) {
      if (key === "request_stock") {
        this.getRequests();
      }
      this.sidebarCollapse = {
        ...this.sidebarCollapse,
        [key]: !this.sidebarCollapse[key]
      };
    },
    searchCode(input) {
      this.value = _.trim(input);
      if (this.value.length > 3) {
        this.value = this.value.substring(0, 3);
      }
      const url = `${process.env.VUE_APP_API_URL}/stock/codes/search2=${encodeURI(this.value)}`;
      let token = webStorage.get("PRIVATE_TOKEN");
      const object = {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': token ? 'Bearer ' + token : 'No token',
        }
      }
      return new Promise(resolve => {
        if (this.value.length < 1) {
          return resolve([]);
        }

        fetch(url, object)
          .then(response => response.json())
          .then(data => {
            if (this.value) {
              resolve(data.items);
            } else {
              resolve([]);
            }
          })
      })
    },
    getResultValue(result) {
      var briefName = '';
      if (result.name) {
        briefName = result.name.replace("Công ty Cổ phần", "")
          .replace("Công ty cổ phần", "")
          .replace("ông ty cổ phần", "")
          .replace("ông ty Cổ phần", "");
      }
      return `${result.code} - ${briefName}`;
    },
    getItemLabel(item) {
      return `${item.code} - ${item.name}`;
    },
    getItemKey(item) {
      return item.code;
    },
    onSubmit(item) {
      this.setDefaultCode(item.code);
      if (item.code) {
        if (this.activeMenu === 'overview') {
          this.getOverview(item.code);
          // this.getStockInfo(item.code);
          // this.getEvaluationCode({ code: item.code, method: 0 });
          // this.getDCACode(item.code);
        } else {
          this.$router.push({ name: 'overview', params: { codeId: item.code } }).catch(() => { });
        }
      }
    },
    clear() {
      this.value = '';
      this.$refs.autocomplete.value = '';
      this.clearDefaultCode();
    },
    selectLanguage(lang) {
      this.setLocale(lang);
    }
  },
  filters: {
    hasRole(name, user) {
      return common.checkRole(name, user);
    }
  }
};
</script>

<style scoped>
.text-button-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.searchText {
  margin-right: 10px;
  height: 35px;
  border-radius: 5px;
  border: 1px solid var(--cyan);
}

.app-search {
  position: relative;
}

.app-search::v-deep .autocomplete-input,
.app-search::v-deep .autocomplete-result {
  background-image: none;
  padding: 12px;
}

.app-search::v-deep .autocomplete[data-loading=true]:after {
  right: 40px;
  animation: rotate 1s linear infinite;
  top: calc(50% - 10px);
}

@keyframes rotate {
  0% {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.time-button {
  display: none;
  position: absolute;
  z-index: 2;
  width: 24px;
  height: 24px;
  top: 50%;
  right: 42px;
  border: none;
  /* background: transparent; */
  padding: 0;
  outline: none;
  transform: translate(calc(100% + 8px), -50%);
}

.value .time-button {
  display: block;
}

.settings-section ul#themecolors li a {
  font-size: 14px;
  line-height: 20px;
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.settings-section ul#themecolors li a.working:before {
  font-size: 14px;
  line-height: 20px;
  width: 20px;
  height: 20px;
}

.user-info .user-info-name {
  vertical-align: middle;
  width: calc(100% - 75px);
  display: inline-block;
  margin-left: 10px;
  margin-top: 7px;
}

.user-info .user-info-name p {
  margin-bottom: 12px;
}

.language-section {
  position: absolute;
  bottom: 10px;
}

.language-section .form-group {
  width: 200px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}

.notification-icon {
  position: relative;
  margin-right: 20px;
  cursor: pointer;
  font-size: 20px;
  color: var(--white);
}

.notification-badge {
  position: absolute;
  top: 0px;
  right: -6px;
  background-color: var(--red);
  color: var(--white);
  border-radius: 50%;
  padding: 2px 6px;
  font-size: 10px;
}
</style>
